module.exports = __webpack_public_path__ + "static/images/styles/images/pure-table/shine.54131234.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/pure-table/shine.png
// module id = 3684
// module chunks = 11